import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * APM WAS 구성정보를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getWasConfigurationInfo(params) {
    return axios.get(`${baseUrl}/performance/summary/apm/get-configuration-info.do`, { params });
  },
  /**
   * 각 위젯별 성능정보를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getSummaryRscRsltList(params) {
    return axios.post(`${baseUrl}/performance/summary/apm/get-${params.summaryWidgetKey.toLowerCase()}-rsc-rslt-list.do`, params);
  },
  /**
   * 각 위젯별 성능 추이 그래프 데이터를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getSummaryRscRsltBackList(params) {
    return axios.post(`${baseUrl}/performance/summary/apm/get-${params.summaryWidgetKey.toLowerCase()}-rsc-rslt-back-list.do`, params);
  },
  /**
   * WAS의 상태를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getInstanceAlive(params) {
    return axios.get(`${baseUrl}/performance/summary/apm/get-instance-alive.do`, { params });
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/apm/was.js